import {
    RECEIVE_ACCOUNTS,
    RECEIVE_ACCOUNT,
    RECEIVE_PRODUCTS,
    RECEIVE_ROLES,
    RECEIVE_USERS,
    RECEIVE_USER,
    SET_CURRENT_PRODUCT,
    SET_CURRENT_ACCOUNT,
    SET_VISIBLE_ACCOUNTS,
    SET_VISIBLE_USERS } from 'actions/data';
import {
    SET_STATUS,
    CLEAR_STATUS } from 'actions/status';
import { Status, StatusType } from 'types/status';

export interface AppDataState {
    accounts: MasterAccountDictionary;  // dictionary of all master accounts the current user
                                        // has access to, indexed by id
    currentAccountId: string;           // guid of current account
    currentAccountDetails?: MasterAccount;
    currentProduct: string;             // current selected product string

    productList: string[];              // de-duped list of 'type' in sub-accounts
    roles: UserRole[];
    status: Status | null;
    users: User[] | null;                      // list of users for current account/product
    visibleUsers: User[] | null;
    visibleAccounts: MasterAccountDictionary; // dictionary master accounts that have sub-account
                                              // with current product, indexed by id
}

// !! exported solely for testing purposes
export const updateUser = (users: User[] | null, user: User | null, appendIfNotPresent: boolean = false) => {
    if (!users) {
        return null;
    }

    if (!user) {
        return users;
    }

    // replace user in existing list if exists
    for (let i = 0; i < users.length; i++) {
        if (users[i].id === user.id) {
            const usersCopy = users.slice();
            // $NOTE: can't just copy over object as the '/user/<id>' api doesn't
            // return the list of roles for the user
            user.roles = usersCopy[i].roles;
            usersCopy[i] = user;
            return usersCopy;
        }
    }

    if (appendIfNotPresent) {
        const usersCopy = users.slice();
        usersCopy.push(user);
        return usersCopy;
    }

    return users;
};

const initialState: AppDataState = {
    accounts: {},
    currentAccountId: '',
    currentProduct: '',
    productList: [],
    roles: [],
    status: {
        message: '',
        title: '',
        type: StatusType.None
    },
    users: null,
    visibleUsers: null,
    visibleAccounts: {}
};

const data = (state = initialState, action: DataAction | null): AppDataState => {
    if (!action) {
        return state;
    }

    switch (action.type) {
        case RECEIVE_ACCOUNTS:
            return Object.assign({}, state, {
                accounts: action.data ?
                    (action.data as MasterAccount[]).reduce(
                        (acc: {[id: string]: MasterAccount}, account: MasterAccount) => {
                            acc[account.id] = account;
                            return acc;
                        },
                        {}) :
                    {}
            });
        case RECEIVE_ROLES:
            return Object.assign({}, state, {
                roles: action.data as UserRole[] || []
            });
        case RECEIVE_PRODUCTS:
            return Object.assign({}, state, {
                productList: action.data
            });
        case RECEIVE_USERS:
            return Object.assign({}, state, {
                users: action.data,
                visibleUsers: action.data
            });
        case RECEIVE_USER:
            const user = action.data as User;
            return Object.assign({}, state, {
                users: updateUser(state.users, user, true),
                visibleUsers: updateUser(state.visibleUsers, user, false)
            });
        case SET_VISIBLE_USERS:
            return Object.assign({}, state, {
                visibleUsers: action.data
            });
        case SET_CURRENT_ACCOUNT:
            return Object.assign({}, state, {
               currentAccountId: action.data as string
            });
        case SET_CURRENT_PRODUCT:
            return Object.assign({}, state, {
                currentProduct: action.data as string
            });
        case SET_STATUS:
            return Object.assign({}, state, {
                status: action.data as Status
            });
        case CLEAR_STATUS:
            return Object.assign({}, state, {
                status: null
            });
        case SET_VISIBLE_ACCOUNTS:
            return Object.assign({}, state, {
                visibleAccounts: action.data ?
                    (action.data as MasterAccount[]).reduce(
                        (acc: {[id: string]: MasterAccount}, account: MasterAccount) => {
                            acc[account.id] = account;
                            return acc;
                        },
                        {}) :
                    {}
            });
        case RECEIVE_ACCOUNT:
            return Object.assign({}, state, {
                currentAccountDetails: action.data as MasterAccount
            });
    }

    return state;
};

export { data };
export default data;



// WEBPACK FOOTER //
// ./src/reducers/data.ts